import { useEffect, useRef } from "react";
import type { ByodGateConfig } from "../scenario/types";
import { ChoiceCard, ChoiceList } from "../ui/ChoiceCard";
import { audio } from "../lib/audio";

export function ByodGate({
  config,
  onChoose,
}: {
  config: ByodGateConfig;
  onChoose: (opt: ByodGateConfig["options"][number]) => void;
}) {
  const spoke = useRef(false);
  useEffect(() => {
    // Prefetch every line this device can speak so the voice pre-render captures branch lines.
    if (config.lenaSafe) void audio.prefetchSpeech(config.lenaSafe, { voice: "nova", lang: config.language ?? "en-US" });
    if (spoke.current) return;
    spoke.current = true;
    void audio.speak(
      config.body ??
        "I'll just use my personal tablet. Games, family photos, three old email accounts…",
      { voice: config.voiceId ?? "onyx", lang: config.language ?? "en-US" }
    );
    return () => audio.cancelSpeech();
  }, [config]);

  const allOk = config.controls.every((c) => c.ok);

  return (
    <div className="rw-panel byodgate">
      <div className="rw-kicker">BYOD check</div>
      <h2>{config.headline ?? "Bring Your Own Disaster?"}</h2>
      {config.body && <p className="rw-body">{config.body}</p>}
      <ul className="byod-controls">
        {config.controls.map((c) => (
          <li key={c.id} className={c.ok ? "ok" : "bad"}>
            <span aria-hidden>{c.ok ? "OK" : "!"}</span>
            {c.label}
          </li>
        ))}
      </ul>
      {!allOk && config.blockedMessage && (
        <p className="rw-hint">{config.blockedMessage}</p>
      )}
      <ChoiceList prompt="Can Max use his personal tablet for work?">
        {config.options.map((o) => (
          <ChoiceCard
            key={o.id}
            category={o.category}
            showRiskLabel={false}
            reply={o.label}
            onClick={() => {
              if (o.safe && config.lenaSafe)
                void audio.speak(config.lenaSafe, {
                  voice: "nova",
                  lang: config.language ?? "en-US",
                });
              onChoose(o);
            }}
          />
        ))}
      </ChoiceList>
    </div>
  );
}
